function cleanAndFormat(value, formatFunc) {
  if (value === null || value === undefined) {
    return `${value}`;
  }

  return formatFunc(value instanceof Date ? value : new Date(value));
}

export default function createTimeFormatter(formatFunc, metadata) {
  const format = value => cleanAndFormat(value, formatFunc);

  if (typeof metadata !== 'undefined') {
    const {
      id,
      label,
      description,
      useLocalTime
    } = metadata;
    format.id = id;
    format.label = label;
    format.description = description;
    format.useLocalTime = useLocalTime;
  }

  return format;
}